module.exports = __webpack_public_path__ + "static/media/codensa.0183f298.png";